import { appName } from "../../../core/schema/appName.js";

export function createTitle(title?: string): string {
	if (!title) {
		return appName;
	} else {
		return `${title} | ${appName}`;
	}
}
